import Multiselect from 'multiselect-react-dropdown'
import styled from 'styled-components'

export const MultiselectContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 6px;

  label {
    color: var(--text-black);
    font-size: 14px;
    line-height: 16px;
  }
`

export const MultiselectCustom = styled(Multiselect)`
  /* Overriding element hover */
  .optionContainer li:hover,
  .optionContainer .highlight {
    background: var(--primary);
    color: #fff;
  }

  /* Placehoolder Color Change */
  .searchBox#css_custom_input::placeholder {
    color: var(--primary);
  }

  /* disabled */
  .disable_ms {
    opacity: 1;
  }
`
